<template>
  <base-modal
    :id="modalId"
    :title="title"
    :is-footer="isFooter"
  >
    <div>
      <p>{{ content }}</p>
      <b-table
        id="duplicate-table"
        :fields="fields"
        :items="duplicatesToResolve"
      >
        <template v-slot:cell(organizationContactPhone)="data">
          <a
            v-if="data.item.organizationContactPhone"
            :href="`tel:${data.item.organizationContactPhone}`"
          >
            {{ phoneNum(data.item.organizationContactPhone) }}
          </a>
        </template>
      </b-table>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';
import transformPhoneNum from '../../util/dataTransformation';

export default {
  name: 'OrganizationDuplicateModal',
  components: { BaseModal },
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    isFooter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalId: 'organization-duplicate-modal',
      fields: [
        {
          key: 'organizationContact',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'organizationName',
          label: 'Organization',
          sortable: true,
        },
        {
          key: 'organizationContactPhone',
          label: 'Phone',
          sortable: false,
        }
      ]
    }
  },
  computed: {
    mainRecip() {
      return this.$store.getters.getDuplicateMain;
    },
    duplicatesToResolve() {
      let dupes = [];
      if (this.$store.getters.getUser) {
        this.$store.getters.getDuplicatesToResolve.forEach((duplicate) => {
          const modifiedDuplicates = duplicate.duplicates.map(item => {
            item.duplicateId = duplicate.id;
            return item;
          });
          dupes = dupes.concat(modifiedDuplicates);
        });
      }
      return dupes;
    },
    duplicateIdsToResolve: function() {
      return this.$store.getters.getDuplicateIdsToResolve;
    }
  },
  mounted() {
    // HACK: Since modals are mounted immediately, we dont know the ids to use yet so this pushs the API call until the modal is shown
    const handleShow = this.handleShow;
    const handleClose = this.handleClose;
    this.$root.$on('bv::modal::show', handleShow);
    this.$root.$on('bv::modal::hide', handleClose);
  },
  methods: {
    handleShow: function(bvModalEvt) {
      if (bvModalEvt.componentId === this.modalId) {
        if (this.duplicateIdsToResolve) {
          this.$store.dispatch('getDuplicateInfo', this.duplicateIdsToResolve);
        }
      }
    },
    handleClose: function(bvModalEvt) {
      if (bvModalEvt.componentId === this.modalId) {
        this.$store.dispatch('clearDuplicateState');
      }
    },
    okHandler: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.closeModal();
    },
    closeModal: async function() {
      await this.$nextTick();
      this.$store.dispatch('clearDuplicateState');
      this.$bvModal.hide(this.modalId);
    },
    phoneNum(phoneNumStr) {
      return transformPhoneNum(phoneNumStr);
    }
  },
}
</script>
